import { render } from "./Write.vue?vue&type=template&id=292ad9d6"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"

import exportComponent from "C:\\servers\\develope\\arbitrage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__